import React, { useState } from 'react';
import LearnerRow from './LearnerRow';

const GroupContainer = ({ 
  group, 
  modules, 
  onUpdateGroupName, 
  onUpdateLearnerName, 
  onAddModule, 
  onRemoveModule 
}) => {
  const [isEditingName, setIsEditingName] = useState(false);
  const [tempName, setTempName] = useState(group.name);
  
  const hasAnyModules = group.learners.some(learner => learner.modules.length > 0);

  const handleNameSubmit = () => {
    onUpdateGroupName(group.id, tempName);
    setIsEditingName(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleNameSubmit();
    } else if (e.key === 'Escape') {
      setTempName(group.name);
      setIsEditingName(false);
    }
  };

  const handleGroupClick = () => {
    setTempName(group.name); // Garder le nom existant, ne pas effacer
    setIsEditingName(true);
  };

  return (
    <div className={`group-container ${hasAnyModules ? 'has-modules' : ''}`} data-testid={`group-${group.id}`}>
      <div className="group-header">
        {isEditingName ? (
          <input
            type="text"
            value={tempName}
            onChange={(e) => setTempName(e.target.value)}
            onBlur={handleNameSubmit}
            onKeyPress={handleKeyPress}
            className="group-name bg-transparent border-b border-[#fa6800] focus:outline-none text-[#2d2d2d] font-semibold"
            autoFocus
            data-testid={`group-name-input-${group.id}`}
            placeholder="Nom du groupe"
          />
        ) : (
          <div 
            className={`group-name cursor-pointer ${group.name ? 'text-[#2d2d2d] font-semibold' : 'text-[#647687] font-normal'}`}
            onClick={handleGroupClick}
            data-testid={`group-name-${group.id}`}
          >
            {group.name || 'Nom du groupe'}
          </div>
        )}
      </div>
      
      <div className="space-y-2">
        {group.learners.map(learner => (
          <LearnerRow
            key={learner.id}
            groupId={group.id}
            learner={learner}
            onUpdateName={onUpdateLearnerName}
            onAddModule={onAddModule}
            onRemoveModule={onRemoveModule}
          />
        ))}
      </div>
    </div>
  );
};

export default GroupContainer;